const data = [
  {
    link: "/blog/optimise-your-sleep-environment/",
    title: "Optimise Your Sleep Environment",
    searchslug: "Optimise Your Sleep Environment",
    description: "",
  },
  {
    link: "/blog/how-often-should-you-replace-your-mattress/",
    title: "How Often Should You Replace Your Mattress",
    searchslug: "How Often Should You Replace Your Mattress",
    description: "",
  },

  {
    link: "/blog/6-signs-you-need-to-replace-your-mattress/",
    title: "6 Signs You Need To Replace Your Mattress",
    searchslug: "6 Signs You Need To Replace Your Mattress",
    description: "",
  },

  {
    link: "/blog/mattress-care-101/",
    title: "Mattress Care 101",
    searchslug: "Mattress Care 101",
    description: "",
  },
  {
    link: "/blog/how-to-fall-asleep-fast/",
    title: "How To Fall Asleep Fast",
    searchslug: "How To Fall Asleep Fast",
    description: "",
  },
  {
    link: "/blog/benefits-of-belgium-latex/",
    title: "Benefits Of Belgium Latex",
    searchslug: "Benefits Of Belgium Latex",
    description: "",
  },
  {
    link: "/blog/benefits-of-memory-foam/",
    title: "Benefits Of Memory Foam",
    searchslug: "Benefits Of Memory Foam",
    description: "",
  },
  {
    link: "/blog/benefits-of-tencel/",
    title: "Benefits Of Tencel",
    searchslug: "Benefits Of Tencel",
    description: "",
  },
  {
    link: "/blog/tencel-vs-cotton/",
    title: "Tencel vs Cotton",
    searchslug: "Tencel vs Cotton",
    description: "",
  },

  {
    link: "/blog/whats-your-sleep-animal/",
    title: "What's your sleep animal?",
    searchslug: "What's your sleep animal",
    description: "",
  },
  {
    link: "/blog/benefits-of-bonnell-spring/",
    title: "Benefits of Bonnell Spring",
    searchslug: "Benefits of Bonnell Spring",
    description: "",
  },

  {
    link: "/blog/bonnell-spring-vs-pocket-spring/",
    title: "Bonnell Spring vs Pocket Spring",
    searchslug: "Bonnell Spring vs Pocket Spring",
    description: "",
  },

  {
    link: "/blog/memory-foam-vs-latex-foam/",
    title: "Memory Foam vs Latex Foam",
    searchslug: "Memory Foam vs Latex Foam",
    description: "",
  },

  {
    link: "/blog/how-sleep-boosts-immunity-system-against-covid-19/",
    title: "How Sleep Boosts Immunity System Against Covid-19",
    searchslug: "How Sleep Boosts Immunity System Against Covid-19",
    description:
      "Explore the relationship between sleep and the body's defences and follow simple steps for a stronger defense against a novel coronavirus infection.",
  },
  {
    link: "/blog/sleep-a-perfect-way-to-regulate-emotions-and-health/",
    title: "Sleep: A Perfect Way To Regulate Emotions And Health",
    searchslug: "Sleep: A Perfect Way To Regulate Emotions And Health",
    description:
      "It's difficult to have a productive day after a sleepless night. Sleepless nights do not only result in unproductive days but much more than that. You can have health issues and bad temperaments too. The ability to make rational decisions also becomes questionable.",
  },
  {
    link: "/blog/good-sleep-makes-better-athletes/",
    title: "Good Sleep Makes Better Athletes",
    searchslug: "Good Sleep Makes Better Athletes",
    description:
      "Explore the relationship between high quality rest and athletic performance in this informative blog from America's Sleep Specialists.",
  },
  {
    link: "/blog/how-can-an-old-mattress-affect-your-sleep/",
    title: "How Can An Old Mattress Affect Your Sleep?",
    searchslug: "How Can An Old Mattress Affect Your Sleep?",
    description:
      "Do you know that mattresses can affect the quality of your sleep? A change of mattress can result in better quality sleep as all the wear and tear of the last mattress will be gone.",
  },
  {
    link: "/blog/all-about-mattresses-for-a-good-night-sleep/",
    title: "All about Mattresses for a Good Night Sleep",
    searchslug: "All about Mattresses for a Good Night Sleep",
    description:
      "Do you know your mattress is an important element when it comes to good night sleep? Bad quality mattress can interrupt your sleep or make you feel exhausted when you wake up in the morning even if you sleep for a night.",
  },
  {
    link: "/blog/new-year-sleep-resolution/",
    title: "New Year Sleep Resolution",
    searchslug: "New Year Sleep Resolution",
    description:
      "Making a new year's resolution is easy but keeping them is what matters. This year make a resolution to improve your sleeping habits by following the simple yet effective steps.",
  },
  {
    link: "/blog/orthopedic-mattresses-for-back-pain/",
    title: "Orthopedic Mattresses for Back Pain?",
    searchslug: "Orthopedic Mattresses for Back Pain?",
    description:
      "Are you suffering from back pain or lower back pain? You might be sleeping on the wrong mattress. Check out what makes the orthopedic mattresses best for the back pain.",
  },
  {
    link: "/blog/the-right-time-to-find-a-new-mattress/",
    title: "The Right Time To Find A New Mattress",
    searchslug: "The Right Time To Find A New Mattress",
    description:
      "Many people experience the effects of a bad/incomplete sleep on next day but many of us fail to recognize what's the reason behind it. Here are a few pointers on which you should really give your attention.",
  },
  {
    link: "/blog/7-habits-of-healthy-sleepers/",
    title: "7 Habits of Healthy Sleepers",
    searchslug: "7 Habits of Healthy Sleepers",
    description:
      "Struggling from sleep disorders make you unhealthy. Transform your sleeping habits and wake up super refreshed and start your day with energetic body and Mind.",
  },
  {
    link: "/blog/the-magic-of-memory-foam/",
    title: "The Magic of Memory Foam",
    searchslug: "The Magic of Memory Foam",
    description:
      "Sleeping on the memory foam mattress has many benefits on both mental and physical health. it improves your sleeping habits and also body posture.",
  },
  {
    link: "/blog/7-ways-to-choose-the-perfect-mattress/",
    title: "7 Ways To Choose The Perfect Mattress",
    searchslug: "7 Ways To Choose The Perfect Mattress",
    description:
      "Without proper guidance, choosing the mattress that suits perfectly is quite difficult. Our guidance to choose the perfect mattress will help you without falling into a trap of salesman.",
  },
];

export default data;
